import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import '../index.scss';

import NewBotSearchTemplate from './NewBotSearchTemplate';
import { BotsCreators } from '../../../store/actions/bots';

const NewBotActions = (props) => {
  const {
    originalTemplateBots,
    setCurrentTemplateList,
    currentTemplateList,
  } = props;

  const onEmptyBotButtonClick = () => {
    const { signedUser } = props;
    if (signedUser?.selectedCompany?.claim?.name) {
      const title = 'Novo Bot';
      const { selectedOrganization: organizationId } = signedUser;
      const companyId = signedUser.selectedCompany._id;
      const { newBotRequest } = props;

      newBotRequest({ title, companyId, organizationId });
    }
  };

  return (
    <div className="new-bot-actions-container">
      <div
        className="new-bot-actions-blank-bot"
        onClick={onEmptyBotButtonClick}
        role="button"
        tabIndex="0"
      >
        <label>Novo bot em branco</label>
      </div>
      <NewBotSearchTemplate
        currentTemplateList={currentTemplateList}
        originalTemplateBots={originalTemplateBots}
        setCurrentTemplateList={setCurrentTemplateList}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    signedUser: state.users.signedUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...BotsCreators }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBotActions);
